<template>
  <div>
    <div v-if="chartType === 'table'" :key="year+'-margins-table'">
      <v-data-table
        :key="marginTableKey"
        :headers="tableHeaders"
        :items="chartData()"
        hide-default-footer
        disable-pagination
        ref="table"
      >
        <template v-slot:item="props">
          <!--<td class="text-xs-left">{{ props.item.number }}</td>-->
          <tr>
            <td class="text-center">
              {{props.index+1}}
            </td>
            <td :key="year+index" v-for="(o,index) in props.item">
              <div v-if="o.margins || o.invoicedMargins" style="border:1px dotted #ccc;" class="pb-2">
                <div v-if="o.margins"><!-- v-if="year <= 2024 && props.index < 7" -->
                  <div style="background:#000;color:#FFF;" class="pl-1"><b>TILAUKSEN</b> pvm mukaan</div>
                  <div class="pl-1">{{ o.margins }}</div>
                  <div v-if="year > 2024 || (year == 2024 && props.index < 7)">
                    <div v-if="allAccess && o.salespersonId && o.customOfficeMargins" class="pr-1" style="text-align:left;font-style:italic;color:darkorange;">Alk. {{ o.originalOfficeMargin }}</div> 
                  </div>
                </div>
                <!-- LASKUTUKSEN MUKAAN -->
                <div v-if="o.invoicedMargins">
                  <div v-if="year > 2024 || (year == 2024 && props.index >= 7)">
                    <div style="background:#FF5722;color:#FFF;" class="pl-1"><b>LASKUTUS</b> pvm mukaan</div>
                    <!-- <div class="pl-1">{{ o.invoicedMargins }}</div> -->
                    <div class="pl-1">Myyjä laskema {{ o.invoicedMarginsSalesperson }}</div>
                    <div class="pl-1" style="color:green;font-weight:600;font-size:10px;">Toimiston kate <span style="font-size:12px;">{{ o.invoicedMarginsOffice }}</span></div>
                    <div v-if="allAccess && o.salespersonId && o.customOfficeMargins" class="pr-1" style="text-align:left;font-style:italic;color:darkorange;">Alk. {{ o.originalOfficeInvoicedMargins }}</div> 
                  </div>
                </div>
                <!-- MAKSETUN MUKAAN -->
                <!-- <div v-if="year >= 2024 && props.index >= 7">
                  <div style="background:#FF5722;color:#FFF;" class="pl-1"><b>MAKSETUN</b> pvm mukaan</div>
                  <div class="pl-1">{{ o.invoicesAllPaidMargins }}</div>
                </div> -->
                
                <input v-if="allAccess && o.salespersonId" placeholder="Aseta toimiston kate" :value="o.customOfficeMargins" type="text"  class="prices-input-header pl-1" @change="v => saveCustomMargin(props.index+1,o.salespersonId, v)">
              </div>
              
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>


<script>
import { mapFields} from 'vuex-map-fields'
import shared from './../../shared'

export default {
    props: ['dataRestriction','chartType','metric', 'label', 'timeFrame', 'dateSplit', 'salesperson', 'year'],
    data: () => ({
      marginTableKey:45678898,
      largeChartFigures:null,
      largeChartVisible:false,
      largeChartTitle:"",
      largeChartOptions:null,
      largeChartData:null,
      largeChartTimeSplit:"month",
      months:[1,2,3,4,5,6,7,8,9,10,11,12],
      years:[2019,2020,2021,2022]
    }),
    watch: {
      orders: {
        handler (val){
        },
        deep: true
      },
      orderedProducts: {
        handler (val){
        },
        deep: true
      }
    },
    computed: {
      ...mapFields([
        "settings",
        "user",
        //'product.products',
        'orderedProduct.orderedProducts',
        "views.salesConsole",
        "company.companies",
        "staff.staff",
        "order.orders",
        "settings.companySelectedInModel",
      ]),
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office')
      },
      
      tableHeaders() {return this.generateTableHeaders(this.salesperson)}
    },
    created () {
      this.generateDeliveryMarginsByOrder = shared.generateDeliveryMarginsByOrder
      this.generateMarginsTableData = shared.generateMarginsTableData

    },
    mounted () {

      //this.generateSalesValues()
      //this.generateMarginValues()
      //this.generateOrdersValues()
      //this.generateNewCustomersValues()
    },
    
    methods: {
      chartData() {
        var deliveryMarginsByOrder = this.generateDeliveryMarginsByOrder()
        var salespersons = this.generateTableHeaders()
        return this.generateMarginsTableData(this.dataRestriction,this.metric, this.chartType, "figures",this.salesperson,"month",this.year,deliveryMarginsByOrder,salespersons)
      },
      saveCustomMargin(month, salespersonId,v){
        var year = this.year
        var value = v.target.value
        value = value.replace(',','.')
        if(isNaN(Number(value))) {
          alert("Syötä luku.")
          this.marginTableKey = this.marginTableKey + 1
          return
        }
        if(!salespersonId){
          alert("Myyjää ei määritelty")
          this.marginTableKey = this.marginTableKey + 1
          return
        }
        value = Number(value)

        //console.log(year, month, salespersonId,value)
        if(this.staff[salespersonId]){
          var customMargins = {}
          if(this.staff[salespersonId].customMargins) customMargins = JSON.parse(JSON.stringify(this.staff[salespersonId].customMargins))
          customMargins[year] ? '' : customMargins[year] = {}
          customMargins[year][month] ? '' : customMargins[year][month] = {}
          customMargins[year][month] = value

          //console.log(customMargins)

          this.$store.dispatch('staff/set', {
            id:salespersonId,
            customMargins,
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      getSalespersons(){

      },
      generateTableHeaders(salesperson){
        var staff = this.staff
        var headers = [{ text: 'Kuukausi', value: 'month', align: 'center', sortable: false },]
        var dataRestriction = this.dataRestriction
        Object.keys(this.staff).forEach(staffId => {
          if(staff[staffId].isExit) return null // Remove exits
          var staffPerson = staff[staffId]
          if(dataRestriction === "none")
            staffPerson.role === "sales" || staffPerson.id === "RqjgIwdXWzXqCR2MOVr1etp2iY22" ? headers.push({ text:staffPerson.firstName, id:staffPerson.id, value: staffPerson.id, align: 'left', sortable: false }) : ""
          else
            staffPerson.id === dataRestriction ? headers.push({ text:staffPerson.firstName, id:staffPerson.id, value: staffPerson.id, align: 'left', sortable: false }) : ""
        });
        //console.log(headers)
        return headers
        
      },
      OLD_generateMarginsTableData(metric, chartType, figureType, split,timeSplit) {
        var orderedProducts = this.orderedProducts
        var orders = this.orders
        var staff = this.staff
        var companies = this.companies
        var figures = {}
        var months = this.months
        var weeks = []
        var figuresByMonth ={}
        figuresByMonth[this.year] = {}
        months.forEach(month => figuresByMonth[this.year][month] = {})
        
        var deliveryMarginsByOrder = this.generateDeliveryMarginsByOrder()

        var getWeek = this.getWeek
        
        if (metric === "orders" || metric === "newCustomers" || metric === "margins" || metric === "bothMargins"  || metric === "marginRate"){
          Object.keys(this.orders).map(function(key, index) {
            var o = orders[key]
            if(typeof companies[o.companyId] === "undefined") return {...o}
            var total = 0
            var total2 = 0
            var month,year = null
            var invoicesAllPaidMonth,invoicesAllPaidYear = null
            var salesperson = o.salesperson
            if(o.originalSalesperson) salesperson = o.originalSalesperson
            
            month = o.created_at.toDate().getMonth() +1
            year = o.created_at.toDate().getFullYear()
            
            var invoicesAllPaid = false
            if(o.invoicesAllPaid && o.invoicesPaidDate && o.invoicesPaidDate.seconds) invoicesAllPaid = true
            
            if(invoicesAllPaid){
              invoicesAllPaidMonth = o.invoicesPaidDate.toDate().getMonth() +1
              invoicesAllPaidYear = o.invoicesPaidDate.toDate().getFullYear()
            }
            
            total = o.salespersonMargin ? Number(o.salespersonMargin) : 0
            total2 = o.officeMargin !== undefined && o.officeMargin ? Number(o.officeMargin) : 0
            //if(metric === "bothMargins" && month === 6 && year === 2020) console.log(o)
            if(figuresByMonth[year] === undefined) figuresByMonth[year] = {}
            if(invoicesAllPaid && figuresByMonth[invoicesAllPaidYear] === undefined) figuresByMonth[invoicesAllPaidYear] = {}
            if(figuresByMonth[year][month] === undefined) figuresByMonth[year][month] = {}
            if(invoicesAllPaid && figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth] = {}
            if(figuresByMonth[year][month]["all"] === undefined) figuresByMonth[year][month]["all"] = {}
            if(invoicesAllPaid && figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"] = {}
            if(figuresByMonth[year][month][salesperson] === undefined) figuresByMonth[year][month][salesperson] = {}
            if(invoicesAllPaid && figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson] = {}

            // ORDER DATE MARGINS ALL
            if (year < 2024 || (year == 2024 && month <= 9)) {
              if(figuresByMonth[year][month]["all"]["margins"] === undefined) figuresByMonth[year][month]["all"]["margins"] = total
              else figuresByMonth[year][month]["all"]["margins"] += total
              
              // ORDER DATE MARGINS BY SALESPERSON
              if(figuresByMonth[year][month][salesperson]["margins"] === undefined) figuresByMonth[year][month][salesperson]["margins"] = total
              else figuresByMonth[year][month][salesperson]["margins"] += total
              // ORDER DATE OFFICE MARGINS ALL
              if(figuresByMonth[year][month]["all"]["officeMargins"] === undefined) figuresByMonth[year][month]["all"]["officeMargins"] = total2
              else figuresByMonth[year][month]["all"]["officeMargins"] += total2
              // ORDER DATE OFFICE MARGINS BY SALESPERSON
              if(figuresByMonth[year][month][salesperson]["officeMargins"] === undefined) figuresByMonth[year][month][salesperson]["officeMargins"] = total2
              else figuresByMonth[year][month][salesperson]["officeMargins"] += total2

              // INVOICED DATE MARGINS ALL
              if(invoicesAllPaid){
                // INVOICES ALL PAID DATE MARGINS ALL
                if(figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"]["invoicesAllPaidMargins"] === undefined) figuresByMonth[year][month]["all"]["invoicesAllPaidMargins"] = total
                else figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"]["invoicesAllPaidMargins"] += total
                // INVOICES ALL PAID DATE MARGINS BY SALESPERSON
                if(figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["invoicesAllPaidMargins"] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["invoicesAllPaidMargins"] = total
                else figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["invoicesAllPaidMargins"] += total
                // INVOICES ALL PAID DATE OFFICE MARGINS ALL
                if(figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"]["invoicesAllPaidOfficeMargins"] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"]["invoicesAllPaidOfficeMargins"] = total2
                else figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth]["all"]["invoicesAllPaidOfficeMargins"] += total2
                // INVOICES ALL PAID DATE OFFICE MARGINS BY SALESPERSON
                if(figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["officeinvoicesAllPaidOfficeMarginsMargins"] === undefined) figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["officeinvoicesAllPaidOfficeMarginsMargins"] = total2
                else figuresByMonth[invoicesAllPaidYear][invoicesAllPaidMonth][salesperson]["invoicesAllPaidOfficeMargins"] += total2
              }
            }
            
            return {...o}
            
          })

          

          Object.keys(this.orderedProducts).forEach(function(opId, index) {
            var op = orderedProducts[opId]
            var o = orders[op.orderId]
            if (!o) return
            var confirmedMargin = op.confirmedMargin ? Number(op.confirmedMargin) : 0
            var salespersonMargin = op.salespersonMargin ? Number(op.salespersonMargin) : 0
            if(isNaN(Number(op.salespersonMargin)) &&  op.salespersonMargin) {
              console.log("INVALID SALESPERSON MARGIN INSERTED")
              console.log(op)
            }
            if(isNaN(Number(op.confirmedMargin)) &&  op.confirmedMargin) {
              console.log("INVALID OFFICE MARGIN INSERTED")
              console.log(op)
            }

            var salesperson = op.salesperson
            if(op.originalSalesperson) salesperson = op.originalSalesperson
            // SUBTRACT DELIVERY MARGIN BY PRODUCT 
            if(deliveryMarginsByOrder[op.orderId]){
              confirmedMargin = confirmedMargin + deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct
              salespersonMargin = salespersonMargin + deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct
              //if(salesperson === 'GJ51vbQ1pLNNJMeKc4896QKdjVr1' && invoicedMonth == 9) console.log(deliveryMarginsByOrder[op.orderId].deliveryMarginPerProduct)
            }

            var created_at = null
            if (op.created_at !== undefined && op.created_at.seconds !== undefined){
              created_at = op.created_at
            }
            else if (op.created_at !== undefined && op.created_at.seconds === undefined) {
              var seconds = new Date(op.created_at).getTime()/1000
              created_at = {seconds}
            }
            var opCreatedMonth = created_at.toDate().getMonth() +1
            var opCreatedYear = created_at.toDate().getFullYear()

            // ORDER DATE MARGINS
            if (opCreatedYear > 2024 || (opCreatedYear == 2024 && opCreatedMonth > 9)) {
              if(figuresByMonth[opCreatedYear] === undefined) figuresByMonth[opCreatedYear] = {}
              if(figuresByMonth[opCreatedYear][opCreatedMonth] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth] = {}
              if(figuresByMonth[opCreatedYear][opCreatedMonth]["all"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth]["all"] = {}
              if(figuresByMonth[opCreatedYear][opCreatedMonth][salesperson] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth][salesperson] = {}

              if(figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["margins"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["margins"] = salespersonMargin
              else figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["margins"] += salespersonMargin
              
              // ORDER DATE MARGINS BY SALESPERSON
              if(figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins"] = salespersonMargin
              else figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["margins"] += salespersonMargin
              // ORDER DATE OFFICE MARGINS ALL
              if(figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["officeMargins"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["officeMargins"] = confirmedMargin
              else figuresByMonth[opCreatedYear][opCreatedMonth]["all"]["officeMargins"] += confirmedMargin
              // ORDER DATE OFFICE MARGINS BY SALESPERSON
              if(figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["officeMargins"] === undefined) figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["officeMargins"] = confirmedMargin
              else figuresByMonth[opCreatedYear][opCreatedMonth][salesperson]["officeMargins"] += confirmedMargin
            }

            // INVOICED ORDERED PRODUCTS MARGINS
            if(op.whenToInvoice && op.orderInvoiceStatus === 'invoiced'){
              // REMOVE BEFORE AUGUST ORDERS

              var created_at = null
              if (o.created_at !== undefined && o.created_at.seconds !== undefined){
                created_at = o.created_at
              }
              else if (o.created_at !== undefined && o.created_at.seconds === undefined) {
                var seconds = new Date(o.created_at).getTime()/1000
                created_at = {seconds}
              }
              var createdMonth = created_at.toDate().getMonth() +1
              var createdYear = created_at.toDate().getFullYear()

              //var createdMonth = o.created_at.toDate().getMonth() +1
              //var createdYear = o.created_at.toDate().getFullYear()
              if(createdYear < 2024  || (createdYear == 2024 && createdMonth < 8)) return
              
              
              var whenToInvoice = null
                            
              if (op.whenToInvoice !== undefined && op.whenToInvoice.seconds !== undefined){
                whenToInvoice = op.whenToInvoice
              }
              else if (op.whenToInvoice !== undefined && op.whenToInvoice.seconds === undefined) {
                var seconds = new Date(op.whenToInvoice).getTime()/1000
                whenToInvoice = {seconds}
              }

              if(!whenToInvoice) return
              var invoicedMonth = whenToInvoice.toDate().getMonth() +1
              var invoicedYear = whenToInvoice.toDate().getFullYear()

              if(figuresByMonth[invoicedYear] === undefined) figuresByMonth[invoicedYear] = {}
              if(figuresByMonth[invoicedYear][invoicedMonth] === undefined) figuresByMonth[invoicedYear][invoicedMonth] = {}
              if(figuresByMonth[invoicedYear][invoicedMonth]["all"] === undefined) figuresByMonth[invoicedYear][invoicedMonth]["all"] = {}
              if(figuresByMonth[invoicedYear][invoicedMonth][salesperson] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson] = {}

              

              //if(salesperson === 'CfssvG9CYWWCoLSkeoR6FVXy6K72' && invoicedYear === 2024 && invoicedMonth === 8 && total > 0) console.log({total,invoicedDay,invoicedMonth,invoicedYear})
              if(figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedOfficeMargins"] === undefined) figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedOfficeMargins"] = confirmedMargin
              else figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedOfficeMargins"] += confirmedMargin
              if(figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedSalespersonMargins"] === undefined) figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedSalespersonMargins"] = salespersonMargin
              else figuresByMonth[invoicedYear][invoicedMonth]["all"]["invoicedSalespersonMargins"] += salespersonMargin
              
              if(figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins"] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins"] = confirmedMargin
              else figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedOfficeMargins"] += confirmedMargin
              if(figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins"] === undefined) figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins"] = salespersonMargin
              else figuresByMonth[invoicedYear][invoicedMonth][salesperson]["invoicedSalespersonMargins"] += salespersonMargin
              //console.log("HERE3", invoicesAllPaidMonth,invoicesAllPaidYear,invoicesAllPaidWeek)
            }
          })

        }
        var year = this.year
        var dataRestriction = this.dataRestriction
        // TABLE DATA
        if(chartType === "table") {
          if (split === "salespersons"){
            //console.log(figuresByMonth)
            figures[year] === undefined ? figures[year] = [] : ""
            var headers = this.generateTableHeaders(this.salesperson)
            Object.keys(figuresByMonth[year]).forEach(function(month,index){
              var data = []

              headers.forEach(header => {
                if(header.id === undefined) return
                
                if(figuresByMonth[year][month][header.id] !== undefined){
                  var salespersonMargins = figuresByMonth[year][month][header.id].margins !== undefined ? figuresByMonth[year][month][header.id].margins.toFixed(2) : 0
                  var officeMargins = figuresByMonth[year][month][header.id].officeMargins !== undefined ? figuresByMonth[year][month][header.id].officeMargins.toFixed(2) : 0

                  
                  var invoicesAllPaidSalespersonMargins = figuresByMonth[year][month][header.id].invoicesAllPaidMargins !== undefined ? figuresByMonth[year][month][header.id].invoicesAllPaidMargins.toFixed(2) : 0
                  var invoicesAllPaidOfficeMargins = figuresByMonth[year][month][header.id].invoicesAllPaidOfficeMargins !== undefined ? figuresByMonth[year][month][header.id].invoicesAllPaidOfficeMargins.toFixed(2) : 0
                  
                  //var invoicedSalespersonMargins = figuresByMonth[year][month][header.id].invoicedMargins !== undefined ? figuresByMonth[year][month][header.id].invoicedMargins.toFixed(2) : 0
                  var invoicedOfficeMargins = figuresByMonth[year][month][header.id].invoicedOfficeMargins !== undefined ? figuresByMonth[year][month][header.id].invoicedOfficeMargins.toFixed(2) : 0
                  var invoicedSalespersonMargins = figuresByMonth[year][month][header.id].invoicedSalespersonMargins !== undefined ? figuresByMonth[year][month][header.id].invoicedSalespersonMargins.toFixed(2) : 0

                  //console.log("-",year,month,header.id,invoicesAllPaidSalespersonMargins)
                  // CHECK FOR CUSTOM MARGIN SET
                  var customOfficeMargins = ''
                  /* console.log("monht", month)
                  if(staff[header.id].customMargins){
                    console.log(staff[header.id].customMargins)
                  } */

                  if(header.id && staff[header.id] && staff[header.id].customMargins && staff[header.id].customMargins[year] && staff[header.id].customMargins[year][month]){
                    customOfficeMargins = staff[header.id].customMargins[year][month]
                  }
                  var marginToShow = officeMargins
                  if(customOfficeMargins && (year < 2024 || (year === 2024 && month < 7))) marginToShow = customOfficeMargins
                  //if(customOfficeMargins) marginToShow = customOfficeMargins
                  //year > 2024 || (year == 2024 && props.index < 7)

                  var officeInvoiceMarginToShow = customOfficeMargins ? customOfficeMargins : invoicedOfficeMargins

                  // SIMPLIEFIED FROM 08/24 FORWARD FOR MARGINS
                  var margins = 'M: '+ salespersonMargins + ', O: ' + marginToShow
                  if((year > 2024 || (year === 2024 && month >= 8))) margins = salespersonMargins


                  if(dataRestriction === "none") 

                    data.push({
                      salespersonId:header.id,
                      margins,
                      originalOfficeMargin: officeMargins,
                      invoicedMargins: 'M: '+invoicedSalespersonMargins + ', O: ' + officeInvoiceMarginToShow,
                      invoicedMarginsSalesperson: invoicedSalespersonMargins,
                      invoicedMarginsOffice:officeInvoiceMarginToShow,
                      originalOfficeInvoicedMargins:invoicedOfficeMargins,
                      customOfficeMargins:customOfficeMargins,
                      invoicesAllPaidMargins: 'M: '+ invoicesAllPaidOfficeMargins+', O:' + invoicesAllPaidSalespersonMargins
                    })
                  else 
                    if(dataRestriction === header.id) {
                      data.push({
                        salespersonId:header.id,
                        margins,
                        originalOfficeMargin: officeMargins,
                        invoicedMargins: 'M: '+invoicedSalespersonMargins + ', O: ' + officeInvoiceMarginToShow,
                        invoicedMarginsSalesperson: invoicedSalespersonMargins,
                        invoicedMarginsOffice:officeInvoiceMarginToShow,
                        originalOfficeInvoicedMargins:invoicedOfficeMargins,
                        customOfficeMargins:customOfficeMargins,
                        invoicesAllPaidMargins: 'M: '+ invoicesAllPaidOfficeMargins+', O:' + invoicesAllPaidSalespersonMargins
                      })
                    }
                }
                else {
                  data.push(0)
                }
              })
              figures[year].push(data)
            })
            return figures[year]
          }

        }
      },
      getWeek(date) {
        var dowOffset = 1
        var newYear = new Date(date.getFullYear(),0,1);
        var day = newYear.getDay() - dowOffset; //the day of week the year begins on
        day = (day >= 0 ? day : day + 7);
        var daynum = Math.floor((date.getTime() - newYear.getTime() - 
        (date.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
        var weeknum;
        //if the year starts before the middle of a week
        if(day < 4) {
            weeknum = Math.floor((daynum+day-1)/7) + 1;
            if(weeknum > 52) {
                nYear = new Date(date.getFullYear() + 1,0,1);
                nday = nYear.getDay() - dowOffset;
                nday = nday >= 0 ? nday : nday + 7;
                /*if the next year starts before the middle of
                  the week, it is week #1 of that year*/
                weeknum = nday < 4 ? 1 : 53;
            }
        }
        else {
            weeknum = Math.floor((daynum+day-1)/7);
        }
        return weeknum;
      }

    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/MarginsMarginTable.vue